export const IN_STOCK = 'IN_STOCK';
export const OUT_OF_STOCK = 'OUT_OF_STOCK';
export const NOT_PHYSICAL = 'digitale';
export const PHYSICAL = 'cartaceo';
export const VIRTUAL_TYPE_ID = 'virtual';
export const SIMPLE_TYPE_ID = 'simple';
export const CONFIGURABLE_TYPE_ID = 'configurable';
export const BUNDLE_TYPE_ID = 'bundle';
export const CONFIGURABLE_TYPENAME = 'ConfigurableProduct';
export const BUNDLE_TYPENAME = 'BundleProduct';
export const BUNDLE_CART_ITEM_TYPENAME = 'BundleCartItem';
export const NO_CONSEGNA = [0, 1, '0', '1'];
export const DURATION_SPAN_DAY = 'D';
export const DURATION_SPAN_MONTHLY = 'M';
export const DURATION_SPAN_QUARTERLY = 'Q';
export const DURATION_SPAN_HALFYEARLY = 'S';
export const DURATION_SPAN_YEARLY = 'Y';
export const DURATION_SPAN_YEARLY_ZUORA = 'A';
export const DURATION_SPAN_BIENNIAL = 'B';

export const ZUORA_BILLING_SPANS_MAP = {
  [DURATION_SPAN_YEARLY_ZUORA]: DURATION_SPAN_YEARLY,
  [DURATION_SPAN_DAY]: DURATION_SPAN_DAY,
  [DURATION_SPAN_MONTHLY]: DURATION_SPAN_MONTHLY,
  [DURATION_SPAN_QUARTERLY]: DURATION_SPAN_QUARTERLY,
  [DURATION_SPAN_HALFYEARLY]: DURATION_SPAN_HALFYEARLY,
  [DURATION_SPAN_BIENNIAL]: DURATION_SPAN_BIENNIAL,
}

export const DURATION_MATCHING = {
  1: 'M',
  3: 'Q',
  6: 'S',
  12: 'Y',
  24: 'B'
}

/** L'ideale sarebbe calcolarlo, mappato per ottimizzare i tempi di esecuzione in caso di molti prodotti contemporaneamente visualizzati */
export const DURATION_MATCHING_REVERSE = {
  'M': 1,
  'Q': 3,
  'S': 6,
  'Y': 12,
  'B': 24,
}

export const SUBSCRIPTION_DEFAULT_BILLING_PERIOD = {
  "Mensile": 'M',
  "Trimestrale": 'Q',
  "Semestrale": 'S',
  "Annuale": 'Y',
  "Biennale": 'B'
}

export const TIPO_RINNOVO_AUTOMATICO = 'RicorrenteMultiutenza';
export const TIPO_RINNOVO_ESPLICITO = 'RinnovoEsplicito';

export const DIGITAL24SKUS = ["QUOTDIG", "Z.00NP_MXXXX_AXXXY"]

export const ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS = {
  B: 'biennale',
  Y: 'annuale',
  S: 'semestrale',
  Q: 'trimestrale',
  M: 'mensile'
}


export const TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE = {
  'libri e collane': 'libro',
  'periodici': 'periodico',
  'software':'software'
}

export const TERMED_ATTRIBUTE_SETS = ['Abbonamento', 'Banche Dati', 'Software', 'Periodici'];

export const QUESITI_ATTRIBUTE_SET_NAME = 'Quesiti';
export const META_PDP_SET_NAME = 'Meta-PDP Set';

export const FEMININE_CATEGORIES = ['tematiche', 'banche dati', 'soluzioni ai', 'certificazioni']

export const GALLERY_IMAGES_RESIZES =  {
            desktop: '?resize=944x708',
            tablet: '?resize=944x708',
            mobile: '?resize=620x465',
            smallMobile: '?resize=745x559'
        }
export const LIBRI_ATTRIBUTE_SET = {key: 15, value: 'libri e collane'}
export const SCALAPAY_ATTRIBUTE_SETS = {...{[LIBRI_ATTRIBUTE_SET.key]: LIBRI_ATTRIBUTE_SET.value}, 16: 'iniziative speciali'}